import { Flex, Table } from 'antd'
import React, { useState, useEffect } from 'react'
import { useFYspjdListQuery } from '../../../store/DianShangYeWuApi'    
import RuleExpenseAdd from './RuleExpenseAdd'
import RuleExpenseEdit from './RuleExpenseEdit'
import RuleExpenseCopy from './RuleExpenseCopy'
function RuleExpenseList(props) {
    const [list, setList] = useState([])
    const {data, isSuccess} = useFYspjdListQuery({fy_spjd_qy_id:props.qy_id});
    useEffect(() => {
        if(isSuccess && data.Status === 'success' && data.Result){
            setList(data.Result)
        }else{
            setList([])
        }
    }, [data, isSuccess])
    const columns = [
        {
            title: '操作',
            dataIndex: 'fy_spjd_id',
            key: 'fy_spjd_id',
            render: (text, record) => <RuleExpenseCopy 
                                        fy_spjd_id={record.fy_spjd_id} 
                                        useList={props.useList} 
                                        deptList={props.deptList} 
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                    />,
        },
        {
            title: '费用单规则名称',
            dataIndex: 'fy_spjd_content',
            key: 'fy_spjd_content',
            render: (text, record) => <RuleExpenseEdit 
                                        fy_spjd_content={text} 
                                        fy_spjd_id={record.fy_spjd_id} 
                                        useList={props.useList} 
                                        deptList={props.deptList} 
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                    />,
        },
        {
            title: '费用单部门',
            dataIndex: 'fy_spjd_bm_name',
            key: 'fy_spjd_bm_name',
        },
        {
            title: '费用单往来类型',
            dataIndex: 'fy_spjd_zflx',
            key: 'fy_spjd_zflx',
        },
        {
            title: '费用单最小金额',
            dataIndex: 'fy_spjd_amount_min',
            key: 'fy_spjd_amount_min',
        },
        {
            title: '费用单最大金额',
            dataIndex: 'fy_spjd_amount_max',
            key: 'fy_spjd_amount_max',
        },
        {
            title: '新增记录',
            dataIndex: 'fy_spjd_uname',
            key: 'fy_spjd_uname',
            render: (text, record) => <span>{record.fy_spjd_uname} {record.fy_spjd_ctime}</span>,
        }
       
    ]
    return (
        <>
            <Flex
                justify='space-between'
                align='center'
               
            >       
               <RuleExpenseAdd 
                    qy_id={props.qy_id}
                    qy_name={props.qy_name}
                    yh_id={props.yh_id}
                    yh_name={props.yh_name}
                    useList={props.useList}
                    deptList={props.deptList}
               />
            </Flex>
            <Table
                columns={columns}
                dataSource={list}
                pagination={false}
                rowKey='fy_spjd_id'
                size='small'
                bordered
                className="custom-table"
                style={{marginTop:'10px'}}
            />
        </>
    )
}

export default RuleExpenseList